import { Box, SxProps } from '@mui/material';
import { useEffect, useState } from 'react';

type Props = {
  children?: React.ReactNode;
  value: number;
  index: number;
  sx?: SxProps;
  className?: string;
  onClick?: () => void;
};
export const TabPanel = ({ children, value, index, sx, className, onClick, ...other }: Props) => {
  const [hasBeenVisible, setHasBeenVisible] = useState(false);

  useEffect(() => {
    if (value === index && !hasBeenVisible) {
      setHasBeenVisible(true);
    }
  }, [value, index, hasBeenVisible]);

  // Don't render children until tab has been visited at least once
  if (!hasBeenVisible) {
    return null;
  }

  return (
    <Box
      role='tabpanel'
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      onClick={onClick}
      className={className}
      sx={{ p: 3, ...sx }}
      {...other}>
      {children}
    </Box>
  );
};
